import {
    PARAMENTOR_RESET,
    PARAMENTOR_BUSY,

    PARAMENTOR_BANDMATERIALIEN_LIST,
    PARAMENTOR_BANDBESCHICHTUNGEN_LIST,
    PARAMENTOR_FORMEN_LIST,
    PARAMENTOR_TRAEGER_TYPEN_LIST,
    PARAMENTOR_TRAEGER_ABMESSUNGEN_LIST,
    PARAMENTOR_VERGUETUNGSARTEN_LIST,
    PARAMENTOR_GEFUEGEARTEN_LIST,
    PARAMENTOR_KUEHLUNGSARTEN_LIST,
    PARAMENTOR_LEISTUNGSVORGABEN_LIST,

    PARAMENTOR_MASCHINENHERSTELLER,
    PARAMENTOR_MASCHINE,
    PARAMENTOR_SAEGEBANDABMESSUNG,
    PARAMENTOR_BANDMATERIALTYP,
    PARAMENTOR_BANDBESCHICHTUNG,
    PARAMENTOR_ERZEUGNIS,
    PARAMENTOR_ERZEUGNIS_WERKSTUECK_FORM,
    PARAMENTOR_ERZEUGNIS_WERKSTUECK_DURCHMESSER,
    PARAMENTOR_ERZEUGNIS_WERKSTUECK_HOEHE,
    PARAMENTOR_ERZEUGNIS_WERKSTUECK_WANDSTAERKE,
    PARAMENTOR_ERZEUGNIS_WERKSTUECK_TRAEGER_TYP,
    PARAMENTOR_ERZEUGNIS_WERKSTUECK_TRAEGER_ABMESSUNG,
    PARAMENTOR_ERZEUGNIS_WERKSTOFF,
    PARAMENTOR_ERZEUGNIS_WERKSTOFFGRUPPE,
    PARAMENTOR_VERGUETUNGSART,
    PARAMENTOR_GEFUEGEART,
    PARAMENTOR_KUEHLUNGSART,
    PARAMENTOR_LEISTUNGSVORGABE,
    PARAMENTOR_LAGENSCHNITT,
    PARAMENTOR_ANZAHLPROLAGE,
    PARAMENTOR_ANZAHLLAGEN,

    PARAMENTOR_PRODUKTE_LIST,
    PARAMENTOR_VORHANDENES_SAEGEBAND,
    PARAMENTOR_VORHANDENES_SAEGEBAND_AUSFUEHRUNGEN_LIST,
    PARAMENTOR_VORHANDENES_SAEGEBAND_AUSFUEHRUNG,

    PARAMENTOR_ERROR_SPANNBEREICH,

    PARAMENTOR_PRODUKTEMPFEHLUNG,
    PARAMENTOR_PARAMETEREMPFEHLUNG,

    PARAMENTOR_KOSTEN_MASCHINENKOSTEN,
    PARAMENTOR_KOSTEN_KOSTENPROBEDIENER,
    PARAMENTOR_KOSTEN_PREISPROBAND,
    PARAMENTOR_KOSTEN_STANDFLAECHE,
    PARAMENTOR_KOSTEN_STANDFLAECHE_TYP,
    PARAMENTOR_KOSTEN_MASCHINENPROBEDIENER,
    PARAMENTOR_KOSTEN_KOSTENERSPARNIS,

    ParamentorActionTypes,
    PARAMENTOR_PRODUKTEMPFEHLUNG_FAVORITES_LIST,
    PARAMENTOR_SESSIONS,
    PARAMENTOR_SESSION_DELETED,
    PARAMENTOR_SESSION_ADDED,
} from "./actiontypes";

import { BezeichnungItem, Maschinenhersteller, Maschine, Saegebandabmessung, Erzeugnis, Produktempfehlung, Parameterempfehlung, SaegebandProdukt, Saegeband, Kostenersparnis, ProduktEmpfehlungFavorit, WerkstoffItem, Session } from './types';

export function paramentorReset(): ParamentorActionTypes {
    return {
        type: PARAMENTOR_RESET,
    }
}

export function paramentorBusy(busy: boolean): ParamentorActionTypes {
    return {
        type: PARAMENTOR_BUSY,
        busy
    }
}

export function paramentorBandmaterialienList(bandmaterialienList: Array<BezeichnungItem>): ParamentorActionTypes {
    return {
        type: PARAMENTOR_BANDMATERIALIEN_LIST,
        bandmaterialienList
    }
}

export function paramentorBandbeschichtungenList(bandbeschichtungenList: Array<BezeichnungItem>): ParamentorActionTypes {
    return {
        type: PARAMENTOR_BANDBESCHICHTUNGEN_LIST,
        bandbeschichtungenList
    }
}

export function paramentorSessions(sessions: Array<Session>): ParamentorActionTypes {
  return {
      type: PARAMENTOR_SESSIONS,
      sessions
  }
}

export function paramentorSessionDeleted(session: Session): ParamentorActionTypes {
  return {
      type: PARAMENTOR_SESSION_DELETED,
      session
  }
}

export function paramentorSessionAdded(session: Session): ParamentorActionTypes {
  return {
      type: PARAMENTOR_SESSION_ADDED,
      session
  }
}

export function paramentorFormenList(formentList: Array<BezeichnungItem>): ParamentorActionTypes {
    return {
        type: PARAMENTOR_FORMEN_LIST,
        formentList
    }
}

export function paramentorTraegerTypenList(traegerTypenList: Array<BezeichnungItem>): ParamentorActionTypes {
    return {
        type: PARAMENTOR_TRAEGER_TYPEN_LIST,
        traegerTypenList
    }
}

export function paramentorTraegerAbmessungenList(traegerAbmesungenList: Array<BezeichnungItem>): ParamentorActionTypes {
    return {
        type: PARAMENTOR_TRAEGER_ABMESSUNGEN_LIST,
        traegerAbmesungenList
    }
}

export function paramentorVerguetungsartList(verguetungsartList: Array<BezeichnungItem>): ParamentorActionTypes {
    return {
        type: PARAMENTOR_VERGUETUNGSARTEN_LIST,
        verguetungsartList
    }
}

export function paramentorGefuegeartenList(gefuegeartenList: Array<BezeichnungItem>): ParamentorActionTypes {
    return {
        type: PARAMENTOR_GEFUEGEARTEN_LIST,
        gefuegeartenList
    }
}

export function paramentorKuehlungsartenList(kuehlungsartenList: Array<BezeichnungItem>): ParamentorActionTypes {
    return {
        type: PARAMENTOR_KUEHLUNGSARTEN_LIST,
        kuehlungsartenList: kuehlungsartenList
    }
}

export function paramentorProdukteList(produkteList: Array<BezeichnungItem>): ParamentorActionTypes {
    return {
        type: PARAMENTOR_PRODUKTE_LIST,
        produkteList: produkteList
    }
}

export function paramentorProdukteAusfuehrungenList(vorhandenesSaegebandAusfuehrungenList: Array<Saegeband>): ParamentorActionTypes {
    return {
        type: PARAMENTOR_VORHANDENES_SAEGEBAND_AUSFUEHRUNGEN_LIST,
        vorhandenesSaegebandAusfuehrungenList
    }
}

export function paramentorSpannbereichError(spannbereichError: boolean): ParamentorActionTypes {
    return {
        type: PARAMENTOR_ERROR_SPANNBEREICH,
        spannbereichError
    }
}

export function paramentorLeistungsvorgabenList(leistungsvorgabenList: Array<BezeichnungItem>): ParamentorActionTypes {
    return {
        type: PARAMENTOR_LEISTUNGSVORGABEN_LIST,
        leistungsvorgabenList
    }
}

export function paramentorMaschinenhersteller(maschinenhersteller?: Maschinenhersteller): ParamentorActionTypes {
    return {
        type: PARAMENTOR_MASCHINENHERSTELLER,
        maschinenhersteller
    }
}

export function paramentorMaschine(maschine?: Maschine): ParamentorActionTypes {
    return {
        type: PARAMENTOR_MASCHINE,
        maschine
    }
}

export function paramentorSaegebandabmessung(saegebandabmessung?: Saegebandabmessung): ParamentorActionTypes {
    return {
        type: PARAMENTOR_SAEGEBANDABMESSUNG,
        saegebandabmessung
    }
}

export function paramentorBandmaterialtyp(bandmaterialtyp: number): ParamentorActionTypes {
    return {
        type: PARAMENTOR_BANDMATERIALTYP,
        bandmaterialtyp: Number(bandmaterialtyp)
    }
}

export function paramentorBandbeschichtung(bandbeschichtung: number): ParamentorActionTypes {
    return {
        type: PARAMENTOR_BANDBESCHICHTUNG,
        bandbeschichtung: Number(bandbeschichtung)
    }
}

export function paramentorErzeugnis(erzeugnis?: Erzeugnis): ParamentorActionTypes {
    return {
        type: PARAMENTOR_ERZEUGNIS,
        erzeugnis: erzeugnis || <Erzeugnis>{ form: 1 }
    }
}

export function paramentorErzeugnisForm(form: number): ParamentorActionTypes {
    return {
        type: PARAMENTOR_ERZEUGNIS_WERKSTUECK_FORM,
        form: Number(form)
    }
}

export function paramentorErzeugnisDurchmesser(durchmesser?: number): ParamentorActionTypes {
    return {
        type: PARAMENTOR_ERZEUGNIS_WERKSTUECK_DURCHMESSER,
        durchmesser: Number(durchmesser)
    }
}

export function paramentorErzeugnisHoehe(hoehe?: number): ParamentorActionTypes {
    return {
        type: PARAMENTOR_ERZEUGNIS_WERKSTUECK_HOEHE,
        hoehe: Number(hoehe)
    }
}

export function paramentorErzeugnisWandstaerke(wandstaerke?: number): ParamentorActionTypes {
    return {
        type: PARAMENTOR_ERZEUGNIS_WERKSTUECK_WANDSTAERKE,
        wandstaerke: Number(wandstaerke)
    }
}

export function paramentorErzeugnisTraegerTyp(traegerTyp?: number): ParamentorActionTypes {
    return {
        type: PARAMENTOR_ERZEUGNIS_WERKSTUECK_TRAEGER_TYP,
        traegerTyp: Number(traegerTyp)
    }
}

export function paramentorErzeugnisTraegerAbmessung(traegerAbmessung?: number): ParamentorActionTypes {
    return {
        type: PARAMENTOR_ERZEUGNIS_WERKSTUECK_TRAEGER_ABMESSUNG,
        traegerAbmessung: Number(traegerAbmessung)
    }
}

export function paramentorErzeugnisWerkstoff(werkstoff?: WerkstoffItem): ParamentorActionTypes {
    return {
        type: PARAMENTOR_ERZEUGNIS_WERKSTOFF,
        werkstoff
    }
}

export function paramentorErzeugnisWerkstoffgruppe(werkstoffgruppe?: number): ParamentorActionTypes {
    return {
        type: PARAMENTOR_ERZEUGNIS_WERKSTOFFGRUPPE,
        werkstoffgruppe: Number(werkstoffgruppe)
    }
}

export function paramentorVerguetungsart(verguetungsart: number): ParamentorActionTypes {
    return {
        type: PARAMENTOR_VERGUETUNGSART,
        verguetungsart: Number(verguetungsart)
    }
}

export function paramentorGefuegeart(gefuegeart: number): ParamentorActionTypes {
    return {
        type: PARAMENTOR_GEFUEGEART,
        gefuegeart: Number(gefuegeart)
    }
}

export function paramentorKuehlungsart(kuehlungsart: number): ParamentorActionTypes {
    return {
        type: PARAMENTOR_KUEHLUNGSART,
        kuehlungsart: Number(kuehlungsart)
    }
}

export function paramentorLeistungsvorgabe(leistungsvorgabe: number): ParamentorActionTypes {
    return {
        type: PARAMENTOR_LEISTUNGSVORGABE,
        leistungsvorgabe: Number(leistungsvorgabe)
    }
}

export function paramentorLagenschnitt(lagenschnitt: boolean): ParamentorActionTypes {
    return {
        type: PARAMENTOR_LAGENSCHNITT,
        lagenschnitt: Boolean(lagenschnitt)
    }
}

export function paramentorAnzahlLagen(anzahlLagen: number): ParamentorActionTypes {
    return {
        type: PARAMENTOR_ANZAHLLAGEN,
        anzahlLagen: Number(anzahlLagen)
    }
}

export function paramentorAnzahlProLage(anzahlProLage: number): ParamentorActionTypes {
    return {
        type: PARAMENTOR_ANZAHLPROLAGE,
        anzahlProLage: Number(anzahlProLage)
    }
}

export function paramentorProduktempfehlung(level: number, produktempfehlung?:Produktempfehlung): ParamentorActionTypes {
    return {
        type: PARAMENTOR_PRODUKTEMPFEHLUNG,
        level,
        produktempfehlung
    }
}

export function paramentorProduktempfehlungFavoritesList(favorites: ProduktEmpfehlungFavorit[]): ParamentorActionTypes {
    return {
        type: PARAMENTOR_PRODUKTEMPFEHLUNG_FAVORITES_LIST,
        favorites
    }
}

export function paramentorParameterempfehlung(level: number, parameterempfehlung?:Parameterempfehlung): ParamentorActionTypes {
    return {
        type: PARAMENTOR_PARAMETEREMPFEHLUNG,
        level,
        parameterempfehlung
    }
}

export function paramentorVorhandenesSaegeband(produkt?: SaegebandProdukt): ParamentorActionTypes {
    return {
        type: PARAMENTOR_VORHANDENES_SAEGEBAND,
        produkt: produkt
    }
}

export function paramentorVorhandenesSaegebandAusfuehrung(saegeband?: Saegeband): ParamentorActionTypes {
    return {
        type: PARAMENTOR_VORHANDENES_SAEGEBAND_AUSFUEHRUNG,
        saegeband
    }
}

export function paramentorMaschinenkosten(maschinenkosten?:number): ParamentorActionTypes {
    return {
        type: PARAMENTOR_KOSTEN_MASCHINENKOSTEN,
        maschinenkosten
    }
}

export function paramentorKostenProBediener(kostenProBediener?:number): ParamentorActionTypes {
    return {
        type: PARAMENTOR_KOSTEN_KOSTENPROBEDIENER,
        kostenProBediener
    }
}

export function paramentorPreisProBand(level: number, preisProBand?:number): ParamentorActionTypes {
    return {
        type: PARAMENTOR_KOSTEN_PREISPROBAND,
        level,
        preisProBand
    }
}

export function paramentorStandflaeche(level: number, standflaeche?:number): ParamentorActionTypes {
    return {
        type: PARAMENTOR_KOSTEN_STANDFLAECHE,
        level,
        standflaeche
    }
}

export function paramentorStandflaecheTyp(level: number, standflaecheTyp:number): ParamentorActionTypes {
    return {
        type: PARAMENTOR_KOSTEN_STANDFLAECHE_TYP,
        level,
        standflaecheTyp
    }
}

export function paramentorMaschinenProBediender(level: number, maschinenProBediener:number): ParamentorActionTypes {
    return {
        type: PARAMENTOR_KOSTEN_MASCHINENPROBEDIENER,
        level,
        maschinenProBediener
    }
}


export function paramentorKostenersparnis(level: number, kostenersparnis?:Kostenersparnis): ParamentorActionTypes {
    return {
        type: PARAMENTOR_KOSTEN_KOSTENERSPARNIS,
        level,
        kostenersparnis
    }
}
